import { jsonFetch } from "@/lib/helpers";
import { Booking } from "@/models/booking";
import { BOOKINGS_URL } from "./api-url.constants";
import { BookingDTO } from "./dtos";
import { mapBookingDTOToBooking } from "./mappers";

export const getBookingById = async (id: string): Promise<Booking> => {
  const bookingDetailsApiDTO = await jsonFetch<{ data: BookingDTO }>(`${BOOKINGS_URL}/${id}`);
  return mapBookingDTOToBooking(bookingDetailsApiDTO.data);
};
